import logo from "./logo.svg";
import "./App.css";
import Navbar from "./component/Navbar";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Home from "./Pages/home/Home";
import Footer from "./component/footer/Footer";
import Login from "./component/login/Login";
import Productlist from "./Pages/productlist/Productlist";
import { ContactProvider } from "./useContext/ContactContext";
import Productdetail from "./Pages/productdetail/Productdetail";
import Order from "./Pages/Order/Order";
import Cart from "./Pages/cart/Cart";
import withAuthRedirect from "./lib/withAuthRedirect";
import OrderDetail from "./Pages/orderdetail/OrderDetail";
import AddAddress from "./Pages/addaddress/AddAddress";
import Privacy from "./Pages/privacy/Privacy";
import Term from "./Pages/termandcondition/Term";
import About from "./Pages/aboutus/About";

import SearchPage from "./Pages/searchpage/SearchPage";
import DropDownAddress from "./Pages/dropdownaddress/DropDownAddress";
import Wallet from "./Pages/wallet/Wallet";
import PreOrder from "./Pages/preorder/PreOrder";
import Subscribe from "./Pages/subscribe/Subscribe";
import EditAddress from "./Pages/editaddress/EditAddress";



function App() {
  const ProtectedWallet = withAuthRedirect(Wallet);
  const ProtectedCart = withAuthRedirect(Cart);
  const ProtectedPreorder = withAuthRedirect(PreOrder);
const ProtectedOrder = withAuthRedirect(Order);
const ProtectedOrderDetail = withAuthRedirect(OrderDetail);
const ProtectedSubscribe = withAuthRedirect(Subscribe);




  return (
    <ContactProvider>
    <Router>
  <div className="w-full bg-Background1 flex justify-center">
   
    <div className="fixed top-0 left-0  w-full z-50">
      <div className="w-full "> 
        <Navbar  />
      </div>
    </div>

  
    <div className="w-full pt-[56px] justify-center ">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id/:mid" element={<Productlist />} />
        <Route path="/productdetail/:id" element={<Productdetail />}/>
        <Route path="/order" element={<ProtectedOrder />} />
        <Route path="/cart" element={<ProtectedCart />} />
        <Route path="/preorder" element={<ProtectedPreorder/>} />
        <Route path="/subscribe" element={<ProtectedSubscribe/>} />
        <Route path="/wallet" element={<ProtectedWallet />} />
        <Route path="/addaddress" element={<AddAddress/>} />
        <Route path="/editaddress/:id" element={<EditAddress/>} />
        <Route path="/addaddresss" element={<DropDownAddress/>} />
        <Route path="/orderdetail/:id"  element={<ProtectedOrderDetail />}/>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/termandcondion" element={<Term />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/searchproduct/:id" element={<SearchPage />} />
      </Routes>

      <style jsx>{`
        .custom-scroll::-webkit-scrollbar {
          width: 6px;
        }

        .custom-scroll::-webkit-scrollbar-thumb {
          background-color: #365282;
          border-radius: 10px;
        }

        .custom-scroll::-webkit-scrollbar-track {
          background-color: #f1f1f1;
        }
      `}</style>

      <Footer />
    </div>
  </div>
</Router>
</ContactProvider>

  );
}

export default App;
